export default __webpack_public_path__ + "static/media/Background_00250.3ef0c4d0.png";